import { useEffect } from "react";
import { useLocation } from "react-router";
import BTBox from "../../../components/BTBox";
import PropTypes from "prop-types";
import { useBTUIController, setLayout } from "../../../context";
function PageLayout({ background, children }) {
  const [, dispatch] = useBTUIController();
  const { pathname } = useLocation();
  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);
  return (
    <BTBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={background}
      sx={{ overflowX: "hidden" }}
    >
      {children}
    </BTBox>
  );
}

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default PageLayout;
